module.exports = __webpack_public_path__ + "static/img/FREMANTLE.9fed175.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FREMANTLE.svg
// module id = q+wX
// module chunks = 0